/**
 * Verifier Agreement Service
 *
 * Wraps the /api/verifier/agreement endpoints.
 */

import api from './api';

const verifierAgreementService = {
  /**
   * Fetch the current agreement text and whether the authenticated user has accepted it.
   * @returns {{ version, title, sections, accepted, acceptedAt }}
   */
  async getAgreement() {
    const response = await api.get('/verifier/agreement');
    return response.data;
  },

  /**
   * Accept the current agreement by typing the user's full name.
   * @param {string} fullName
   * @returns {{ success, accepted, acceptedAt, version }}
   */
  async acceptAgreement(fullName) {
    const response = await api.post('/verifier/agreement/accept', { fullName });
    return response.data;
  },
};

export default verifierAgreementService;
